import { render, staticRenderFns } from "./_Channels.vue?vue&type=template&id=7dd36960&scoped=true&"
import script from "./_Channels.vue?vue&type=script&lang=ts&"
export * from "./_Channels.vue?vue&type=script&lang=ts&"
import style0 from "./_Channels.vue?vue&type=style&index=0&id=7dd36960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd36960",
  null
  
)

export default component.exports